import { useState } from "react";
import { Snackbar } from "@mui/material";

import { baseUrl, hostbaseUrl } from "../../shared/baseUrl";

const CopyToClipboardCertificate = ({ id }: any) => {
  const [open, setOpen] = useState(false);

  const handleClick = (e: any) => {
    e.preventDefault();
    setOpen(true);
    // eslint-disable-next-line no-useless-concat
    navigator.clipboard.writeText(`${hostbaseUrl}/certificateX27QF0rPxLljNoAq71sgROuRuJd0A40aApO_EALw_wcB=preview/${id}`);
  };

  return (
    <div >
      <button className='certificate-button' onClick={handleClick} >
        Copy Link
      </button>
      <Snackbar
        message="Copied to clibboard"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={2000}
        onClose={() => setOpen(false)}
        open={open}
      />
    </div>
  );
};

export default CopyToClipboardCertificate;
